import { CalendarSection } from '../../Calendar'
import { Container } from '../Container'

function CalendarSections() {
  return (
    <Container label='Calendar section on the mock feed'>
      <CalendarSection />
    </Container>
  )
}

export default CalendarSections
